export const urlPattern = /(https?:\/\/)?([^\s]+\/g\/[^\s]+)/;

export const localhostWithPortPattern = /localhost:(\d+)/;

export const FE_DOMAIN_NO_HTTPS = 'triton.anemon.fr';
